/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { campaignAnalysisResultSchema } from '../campaign-schema';

export const getCampaignAnalysisResultPathSchema = z.object({
  campaignId: z.string(),
  runId: z.string(),
});

export const getCampaignAnalysisResultOperationResponseSchema =
  campaignAnalysisResultSchema;

export type GetCampaignAnalysisResultInput = {
  path: z.input<typeof getCampaignAnalysisResultPathSchema>;
  signal?: AbortSignal;
};

export async function getCampaignAnalysisResult({
  path,
  signal,
}: GetCampaignAnalysisResultInput): Promise<
  z.infer<typeof getCampaignAnalysisResultOperationResponseSchema>
> {
  const parsedPath = getCampaignAnalysisResultPathSchema.parse(path);

  const response = await socialApiClient.get(
    `campaigns/${parsedPath.campaignId}/analyses/${parsedPath.runId}/result`,
    {
      signal,
    },
  );
  return getCampaignAnalysisResultOperationResponseSchema.parse(
    await response.json(),
  );
}
